import {
    UilEstate,
    UilClipboardAlt,
    UilUsersAlt,
    UilPackage,
    UilChart,
    UilUsdSquare,
    UilMoneyWithdrawal,
    
    

} from '@iconscout/react-unicons';
import img1 from '../imgs/img1.png'
import img2 from '../imgs/img2.png'
import img3 from '../imgs/img3.png'


export const SidebarData = [
    {
        icon:UilEstate,
        heading:'DashBoard'
    },
    {
        icon:UilClipboardAlt,
        heading:'Orders',
    },{
        icon:UilUsersAlt,
        heading:'Customers',
    },
    {
        icon:UilPackage,
        heading:'Products',
    },
    {
        icon:UilChart,
        heading:'Analytics'
    }
]

export const CardsData = [
    {
        title:'Order',
        color: {
          backGround: "linear-gradient(180deg, #bb67ff 0%, #c484f3 100%)",
          boxShadow: "0px 10px 20px 0px #e0c6f5",
        },
        barValue: 70,
        value: '1,284',
        png: UilUsdSquare ,
        series:[{
            name:"Sales",
            data:[25,28,51,42,109]
        }
        ]},
        {
            title: "Total Sales",
            color: {
              backGround: "linear-gradient(180deg, #FF919D 0%, #FC929D 100%)",
              boxShadow: "0px 10px 20px 0px #FDC0C7",
            },
            barValue: 80,
            value: "2,45,000",
            png: UilMoneyWithdrawal,
            series: [
              {
                name: "Revenue",
                data: [10, 100, 50, 70, 80, 30, 40],
              },
            ],
          },
          {
            title: "Marketing Cos",
            color: {
              backGround:
                "linear-gradient(rgb(248, 212, 154) -146.42%, rgb(255 202 113) -46.42%)",
              boxShadow: "0px 10px 20px 0px #F9D59B",
            },
            barValue: 60,
            value: "₹38,000",
            png: UilClipboardAlt,
            series: [
              {
                name: "Expenses",
                data: [10, 25, 15, 30, 12, 15, 20],
              }
              ]
            }
            ]


export const UpdatesData = [
  {
    img:img1,
    name:'Piyush',
    note: " has ordered Apple Iphone 17.",
    time: "1 min ago"
  },
  {
    img:img2,
    name:'Shubham',
    note:' has received the Nike Air Shoes.',
    time:"30 mins ago",
  },
  {
    img:img3,
    name:'Pragya',
    note:' has ordered the Park Avenue Soap',
    time:'1 hour ago',

  },
 

]